import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {CdkConnectedOverlay, CdkOverlayOrigin, ConnectedPosition} from '@angular/cdk/overlay';
import {ClickService} from '../../../core/services/click.service';
import {Subscription} from 'rxjs';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'motn-keypad',
  templateUrl: './keypad.component.html',
  styleUrls: ['./keypad.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CdkOverlayOrigin,
    CdkConnectedOverlay,
    FormsModule,
  ],
})
export class KeypadComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() initialValue: number;

  /**
   * Called when user clicks the checkmark
   */
  @Output() done$: EventEmitter<number> = new EventEmitter<number>();
  /**
   * Called when user backs out of the keypad
   */
  @Output() cancel$: EventEmitter<null> = new EventEmitter<null>();

  /**
   * value will only be a string if the user has just typed a decimal point
   * and has not yet added numbers after the decimal point
   */
  value: string;
  valid: boolean = true;

  private clickSub: Subscription;

  overlayPositions: ConnectedPosition[] = [{
    originX: 'center',
    originY: 'top',
    overlayX: 'center',
    overlayY: 'top',
  }];


  // @ViewChild('input') keypadInputRef: ElementRef;


  constructor(
    private eRef: ElementRef,
    private clickService: ClickService,
  ) {
  }


  ngOnInit(): void {
    this.value = '' + this.initialValue;

    this.clickSub = this.clickService.click$.subscribe(
      ($el) => {
        if (!this.eRef.nativeElement.contains($el)) {
          this.cancel$.emit(null);
        }
      },
    );
  }


  ngAfterViewInit() {
    // this.keypadInputRef.nativeElement.focus();
  }


  ngOnDestroy() {
    this.clickSub?.unsubscribe();
  }


  validate() {
    const re = /^-?[0-9]*\.?[0-9]+$/;
    this.valid = re.test(this.value);
  }


  clickDone(): void {
    if (this.valid) {
      this.done$.emit(+this.value);
    }
  }


  clickCancel(): void {
    this.cancel$.emit(null);
  }


  backspace(): void {
    let strVal = '' + this.value;
    strVal = strVal.substr(0, strVal.length - 1);
    this.value = strVal;
    this.validate();
  }


  addDecimal(): void {
    let strVal = '' + this.value;
    if (strVal.indexOf('.') === -1) {
      strVal = strVal + '.';
    }

    this.value = strVal;
    this.validate();
  }


  addNumeric(int: number) {
    let strVal = '' + this.value + +int;
    this.value = strVal;
    this.validate();
  }
}
